import React, { useState, useEffect } from 'react';
import api from '../../api';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaEye, FaEyeSlash, FaUser, FaLock } from 'react-icons/fa';
import logo from '../../assets/aita-logo.png';
import './EstadoCuenta.css';

export default function EstadoCuenta() {
  const [usuario, setUsuario]     = useState('');
  const [clave, setClave]         = useState('');
  const [error, setError]         = useState('');
  const [showClave, setShowClave] = useState(false);
  const [loading, setLoading]     = useState(false);
  const navigate                  = useNavigate();
  const [searchParams]            = useSearchParams();
  const sesionExpirada            = searchParams.get('sesion') === 'expirada';

  useEffect(() => {
    document.title = 'AITA - Iniciar sesión';
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (!usuario || !clave) {
      setError('Por favor completa todos los campos');
      return;
    }
    setLoading(true);
    try {
      let response;
      if (usuario.includes('@')) {
        response = await api.post('/auth/login', { email: usuario, password: clave });
        const { token, role, warehouse_code: warehouse, id } = response.data;
        localStorage.setItem('token', token);
        localStorage.setItem('role', role);
        localStorage.setItem('warehouse', warehouse);
        localStorage.setItem('userId', id);
        localStorage.setItem('userEmail', usuario);
        navigate('/menu');
      } else {
        response = await api.post('/auth/cliente-login', { clie_id: Number(usuario), nip: clave });
        const { token } = response.data;
        localStorage.setItem('token', token);
        localStorage.setItem('clieId', usuario);
        localStorage.setItem('role', 'usuario');
        navigate('/usuario');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error de servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="ec-hero"
      style={{
        backgroundImage: "url('/fondologin.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="ec-overlay" />

      <div className="ec-card">
        {/* Marca */}
        <div className="ec-brand">
          <img src={logo} alt="AITA" className="ec-logo" />
          <p className="ec-tagline">Siempre contigo</p>
          <span className="ec-divider" />
        </div>

        {/* Formulario */}
        <form onSubmit={handleSubmit} className="ec-form">
          <h2 className="ec-title">Iniciar sesión</h2>

          {sesionExpirada && (
            <p className="ec-aviso-sesion">Tu sesión expiró. Vuelve a iniciar sesión.</p>
          )}

          <div className="ec-field">
            <FaUser className="ec-field-icon" />
            <input
              type="text"
              placeholder="Email o ID de Cliente"
              value={usuario}
              onChange={e => setUsuario(e.target.value)}
              required
            />
          </div>

          <div className="ec-field">
            <FaLock className="ec-field-icon" />
            <input
              type={showClave ? 'text' : 'password'}
              placeholder="Contraseña o NIP"
              value={clave}
              onChange={e => setClave(e.target.value)}
              required
            />
            <button
              type="button"
              className="ec-eye"
              onClick={() => setShowClave(v => !v)}
              aria-label={showClave ? 'Ocultar contraseña' : 'Mostrar contraseña'}
            >
              {showClave ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          {error && <p className="ec-error">{error}</p>}

          <button type="submit" className="ec-btn" disabled={loading}>
            {loading ? 'Ingresando…' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
